<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Urun"
    }
</script>

<style scoped>

</style>